import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";

/**
 * Centered overlay dialog with a dimmed backdrop. Closes on backdrop click,
 * Escape, or the close button (Headless UI handles focus trapping). Used to
 * present content "over" the current page without a full navigation.
 */
function Modal({ open, onClose, children, panelClassName = "max-w-3xl" }) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4 sm:p-6">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 translate-y-2 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-2 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative w-full ${panelClassName} my-8`}
              >
                <button
                  type="button"
                  onClick={onClose}
                  aria-label="Close"
                  className="absolute -top-3 -right-3 z-10 rounded-full bg-white p-1.5 text-gray-500 shadow-md ring-1 ring-gray-900/5 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-fairblue-500"
                >
                  <XIcon className="h-5 w-5" />
                </button>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default Modal;
